export const DATE_FORMAT = "DD MMM YYYY";

export const TIME_FORMAT = " hh:mma";
